/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthRequest } from '../models/AuthRequest';
import type { AuthResponse } from '../models/AuthResponse';
import type { DemoRequest } from '../models/DemoRequest';
import type { DemoResponse } from '../models/DemoResponse';
import type { OkResult } from '../models/OkResult';
import type { PasswordResetRequest } from '../models/PasswordResetRequest';
import type { RegisterModel } from '../models/RegisterModel';
import type { SignupRequest } from '../models/SignupRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
  /**
   * @param requestBody
   * @returns DemoResponse OK
   * @throws ApiError
   */
  public static postApiAuthDemo(
    requestBody?: DemoRequest,
  ): CancelablePromise<DemoResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/demo',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static getApiAuthProfile(): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Auth/profile',
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static postApiAuthLogin(
    requestBody?: AuthRequest,
  ): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static postApiAuthSignup(
    requestBody?: SignupRequest,
  ): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/signup',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param userId
   * @param code
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static getApiAuthConfirmEmail(
    userId?: string,
    code?: string,
  ): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Auth/confirm-email',
      query: {
        'userId': userId,
        'code': code,
      },
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param formData
   * @returns void
   * @throws ApiError
   */
  public static postApiAuthExternalLogin(
    formData?: {
      Provider: string;
      Redirect: string;
    },
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/external-login',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        302: `Found`,
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param returnUrl
   * @param remoteError
   * @returns OkResult OK
   * @throws ApiError
   */
  public static getApiAuthExternalLoginCallback(
    returnUrl?: string,
    remoteError?: string,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Auth/external-login-callback',
      query: {
        'returnUrl': returnUrl,
        'remoteError': remoteError,
      },
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiAuthRegister(
    requestBody?: RegisterModel,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/register',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiAuthLogout(): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/logout',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiAuthForgotPassword(
    requestBody?: string,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/forgot-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiAuthResetPassword(
    requestBody?: PasswordResetRequest,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Auth/reset-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
}
